import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SwapVert } from '@mui/icons-material'
import styled from '@emotion/styled'
import { Collapse, IconButton, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { INotification } from 'types/notification'
import { formatTimeStampToDateWithTime } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'

const StyledTableCell = styled(TableCell)({
  fontSize: '14px !important',
})

function Row(props: { row: INotification; index: number }) {
  const { row, index } = props
  const [open, setOpen] = React.useState(false)
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <StyledTableCell width="50px" align="center">
          {index + 1}
        </StyledTableCell>
        <StyledTableCell>{row.organizationName}</StyledTableCell>
        <StyledTableCell>
          {formatTimeStampToDateWithTime(row.createTime?.toString() as string)}
        </StyledTableCell>
        <StyledTableCell align="center" width="50px">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </StyledTableCell>
      </TableRow>
      <TableRow sx={{ padding: 0 }}>
        <TableCell style={{ padding: 0, background: '#fafbfb' }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ padding: '16px 20px' }}>
              <Box sx={{ marginBottom: '16px' }}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                    color: '#000',
                  }}
                >
                  {t('notif-text')}
                </Typography>
                <Typography
                  sx={{
                    color: '#8a94a6',
                  }}
                  variant="caption"
                >
                  {row.messageBody}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('contact-person')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.personalName}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('contact-person-number')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.phoneNumber}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '20px',
                      color: '#000',
                    }}
                  >
                    {t('other-contacts')}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#8a94a6',
                    }}
                    variant="caption"
                  >
                    {row.email}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

type Props = {
  data: INotification[]
}

export function NotificationsTable({ data }: Props) {
  const { t } = useTranslation()
  return (
    <Box sx={{ overflow: 'auto' }}>
      <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
        <TableContainer component={Box}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <SwapVert
                    sx={{
                      color: '#8a94a6',
                      fontSize: '22px',
                    }}
                  />
                </TableCell>
                <TableCell>{t('tender-organization-name')}</TableCell>
                <TableCell>{t('date')}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: INotification, index: number) => (
                <Row key={row.id} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
